import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import { useSelector } from "react-redux";
import { useSortBy, useTable } from "react-table";
import "../styles/section-chef.css";

import Draft from "../../assets/draft.png";
import Publish from "../../assets/publish.png";
import { printDishLabel } from "../../utils/printLabelUtils";

const Table = ({ data, deleteItem, hideItem, live, chef }) => {
  const history = useHistory();
  let lang = useSelector((state) => state.lang);

  useEffect(() => {}, [live]);

  const columns = useMemo(
    () => [
      {
        Header: "Image",
        accessor: "pic",
        Cell: ({ row }) =>
          row.original.pic === null ? (
            <div
              style={{
                width: 100,
                height: 60,
                backgroundColor: "#d9d9d9",
                marginTop: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 600
                }}
              >
                {t("buttons.add_a_photo", lang)}
              </span>
            </div>
          ) : (
            <img
              src={row.original.pic}
              alt="Product"
              style={{ width: 100, height: 60, objectFit: "cover" }}
            />
          )
      },
      {
        Header: t("common.price_4", lang),
        accessor: "price",
        Cell: ({ row }) => (
          <div>
            <span
              style={{
                color: "#ff114d"
              }}
            >
              <b>${row.original.cost}</b>
            </span>
            <span>
              <i className="fa fa-sort" />
            </span>
          </div>
        )
      },
      {
        Header: t("table.actions", lang),
        accessor: "actions",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            {[
              {
                text:
                  row.original.visible === false
                    ? t("common.make_visible", lang)
                    : t("common.hide_it", lang),
                value: "hide-seen"
              },
              {
                text: t("buttons.edit_dish", lang),
                value: "edit"
              },
              {
                text: t("buttons.print_label", lang),
                value: "print-label"
              },
              {
                text: t("buttons.delete", lang),
                value: "delete"
              }
            ].map((item, index) => (
              <span
                className="action-btn-food"
                key={index}
                style={{
                  color: item.value === "delete" ? "#ff114d" : "#000",
                  textDecorationLine: "underline"
                }}
                onClick={() => {
                  if (item?.value === "delete") {
                    return deleteItem(row.original._id);
                  }
                  if (item?.value === "hide-seen") {
                    return hideItem(
                      row.original._id,
                      row?.original?.visible === false ? true : false
                    );
                  }
                  if (item?.value === "print-label") {
                    return printDishLabel(row.original, chef || {}, lang, {
                      by: t("modals.by", lang),
                      bestBy: t("form.best_by", lang),
                      heatingInstructions: t("form.heating_instructions", lang),
                      microwave: t("form.microwave", lang),
                      oven: t("form.oven", lang),
                      stovetop: t("form.stovetop", lang),
                      price: t("form.price", lang),
                      portion: t("form.portion", lang),
                      servings: t("form.servings", lang),
                      spiceLevel: t("form.spicy_level", lang),
                      foodType: t("form.food_type", lang),
                      allergens: t("form.allergens", lang),
                      contains: t("form.contains", lang),
                      noAllergens: t("form.no_allergens", lang),
                      ingredients: t("form.ingredients", lang),
                      enjoyMeal: t("form.enjoy_meal", lang)
                    });
                  }
                  return history.push(
                    "/chef/iam-a-chef/edit-menu?food-selected=" +
                      row.original._id
                  );
                }}
              >
                {item?.text}
              </span>
            ))}
          </div>
        )
      },
      {
        Header: t("common.dish_name_2", lang),
        accessor: "name"
      },
      {
        Header: t("common.available", lang),
        accessor: "available",
        Cell: ({ row }) => (
          <>
            {/* {JSON.stringify(live)} */}
            <img
              alt="img-draft"
              src={live === "live" ? Publish : Draft}
              style={{
                width: live === "live" ? 60 : 75,
                objectFit: "contain"
              }}
            />
          </>
        )
      },
      {
        Header: t("common.food_type_4", lang),
        accessor: "food_type",
        Cell: ({ row }) => (
          <div
            style={{
              padding: 5,
              minWidth: 100,
              maxWidth: 150,
              height: 40,
              backgroundColor: "#ff114d",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 20
            }}
          >
            {lang === "en"
              ? row?.original?.food_type?.eng_name
              : row?.original?.food_type?.name}
          </div>
        )
      },
      {
        Header: "Limit/Day",
        accessor: "limit"
      },
      {
        Header: t("common.status_2", lang),
        accessor: "status",
        Cell: ({ row }) => (
          <div
            style={{
              padding: 5,
              minWidth: 100,
              maxWidth: 120,
              height: 40,
              backgroundColor:
                row?.original?.status === false
                  ? "rgba( 228, 25, 25, 0.25 )"
                  : "rgba( 68, 255, 68, 0.25 )",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: row?.original?.status === false ? "#ff114d" : "green",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 20
            }}
          >
            {row?.original?.status === false
              ? t("table.inactive", lang)
              : t("table.active", lang)}
          </div>
        )
      },
      {
        Header: t("common.visible", lang),
        accessor: "visible",
        Cell: ({ row }) => (
          <div
            style={{
              padding: 5,
              minWidth: 100,
              maxWidth: 120,
              height: 40,
              backgroundColor:
                row?.original?.visible === false
                  ? "rgba( 228, 25, 25, 0.25 )"
                  : "rgba( 68, 255, 68, 0.25 )",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: row?.original?.visible === false ? "#ff114d" : "green",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 20
            }}
          >
            {row?.original?.visible === false
              ? t("table.inactive", lang)
              : t("table.active", lang)}
          </div>
        )
      }
    ],
    [lang]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data
      },
      useSortBy
    );

  return (
    <div className="table-container">
      <table {...getTableProps()} className="table-menu">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="table-header-menu"
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="table-header-cell-menu"
                >
                  {column.render("Header")}
                  {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="table-body-menu">
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="table-row-menu">
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="table-cell-menu">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
